export default __webpack_public_path__ + "locales/sr-Cyrl-RS/InfoPanel.json?hash=d57823d2f707a438f52bd22a78c8c7d8";